// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { invItemId } from './InvItem';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationPlannedItem = z.object({
    fermentation_id: fermentationId,
    item_id: invItemId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const fermentationPlannedItemInitializer = z.object({
    fermentation_id: fermentationId,
    item_id: invItemId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const fermentationPlannedItemMutator = z.object({
    fermentation_id: fermentationId.optional(),
    item_id: invItemId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationPlannedItem.js.map